export const getSppech = (id: string, langKey: string) => {
 return `https://d2v5p8jgjm0j1e.cloudfront.net/${id}/${langKey}.mp3`;
};
